import React from "react";
import PropTypes from "prop-types";
import {
  SuccessFlash,
  LoadingFlash,
  ErrorFlash,
} from "@grnhse/seedling/lib/birch/components/flash";

export type FlashType =
  | "success"
  | "error"
  | "errors"
  | "notice"
  | "alert"
  | "pending";

type Props = {
  type: FlashType;
  message: string;
};

const Flash = ({ type, message }: Props) => {
  if (type === "success" || type === "notice") {
    return <SuccessFlash message={message} />;
  } else if (type === "error" || type === "errors" || type === "alert") {
    return <ErrorFlash message={message} />;
  } else {
    return <LoadingFlash message={message} />;
  }
};

Flash.propTypes = {
  type: PropTypes.string,
  message: PropTypes.string,
};

export { Flash };
